import type { UmbMockMemberTypeModel } from '../data/mock-data-set.types.js';
import { UmbEntityMockDbBase } from './utils/entity/entity-base.js';
import { UmbMockEntityTreeManager } from './utils/entity/entity-tree.manager.js';
import { UmbMockEntityNamedItemManager } from './utils/entity/entity-named-item.manager.js';
import { UmbMockEntityDetailManager } from './utils/entity/entity-detail.manager.js';
import { pagedResult } from './utils/paged-result.js';
import { UmbId } from '@umbraco-cms/backoffice/id';
import type {
	AllowedMemberTypeModel,
	CreateMemberTypeRequestModel,
	MemberTypeItemResponseModel,
	MemberTypeResponseModel,
	PagedAllowedMemberTypeModel,
} from '@umbraco-cms/backoffice/external/backend-api';

class UmbMemberTypeMockDB extends UmbEntityMockDbBase<UmbMockMemberTypeModel> {
	tree = new UmbMockEntityTreeManager<UmbMockMemberTypeModel>(this, memberTypeTreeItemMapper);
	item = new UmbMockEntityNamedItemManager<UmbMockMemberTypeModel>(this, itemResponseMapper);
	detail = new UmbMockEntityDetailManager<UmbMockMemberTypeModel>(this, createDetailMockMapper, detailResponseMapper);

	constructor(data: Array<UmbMockMemberTypeModel>) {
		super('memberType', data);
	}

	getAllowedAtRoot(skip = 0, take = 100): PagedAllowedMemberTypeModel {
		const mockItems = this.data.filter((item) => item.allowedAsRoot);
		const mappedItems = mockItems.map((item) => allowedMemberTypeMapper(item));
		return pagedResult(mappedItems, skip, take);
	}
}

const createDetailMockMapper = (request: CreateMemberTypeRequestModel): UmbMockMemberTypeModel => {
	return {
		id: request.id ? request.id : UmbId.new(),
		name: request.name,
		description: request.description,
		alias: request.alias,
		icon: request.icon,
		properties: request.properties,
		containers: request.containers,
		allowedAsRoot: request.allowedAsRoot,
		allowedInLibrary: request.allowedInLibrary,
		variesByCulture: request.variesByCulture,
		variesBySegment: request.variesBySegment,
		isElement: request.isElement,
		compositions: request.compositions,
		noAccess: false,
		hasChildren: false,
		parent: null,
		hasListView: false,
		isFolder: false,
		flags: [],
	};
};

const detailResponseMapper = (item: UmbMockMemberTypeModel): MemberTypeResponseModel => {
	return {
		name: item.name,
		id: item.id,
		description: item.description,
		alias: item.alias,
		icon: item.icon,
		properties: item.properties,
		containers: item.containers,
		allowedAsRoot: item.allowedAsRoot,
		allowedInLibrary: false,
		variesByCulture: item.variesByCulture,
		variesBySegment: item.variesBySegment,
		isElement: item.isElement,
		compositions: item.compositions,
	};
};

const memberTypeTreeItemMapper = (item: UmbMockMemberTypeModel): any => {
	return {
		name: item.name,
		hasChildren: item.hasChildren,
		id: item.id,
		parent: item.parent,
		isFolder: false,
		icon: item.icon,
	};
};

const itemResponseMapper = (item: UmbMockMemberTypeModel): MemberTypeItemResponseModel => {
	return {
		id: item.id,
		name: item.name,
		icon: item.icon,
		flags: item.flags,
	};
};

const allowedMemberTypeMapper = (item: UmbMockMemberTypeModel): AllowedMemberTypeModel => {
	return {
		id: item.id,
		name: item.name,
		description: item.description,
		icon: item.icon,
	};
};

export const umbMemberTypeMockDb = new UmbMemberTypeMockDB([]);
